import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import FloorView from "@/pages/FloorView";
import Reconciliation from "@/pages/Reconciliation";
import Network from "@/pages/Network";
import Locations from "@/pages/Locations";
import Documents from "@/pages/Documents";
import Devices from "@/pages/Devices";
import Servicing from "@/pages/Servicing";
import Alerts from "@/pages/Alerts";
import Integrations from "@/pages/Integrations";
import Settings from "@/pages/Settings";
import Profile from "@/pages/Profile";
import AccessGate from "@/components/AccessGate";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50 text-zinc-500">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="floor" element={<FloorView />} />
        <Route path="reconciliation" element={<Reconciliation />} />
        <Route path="network" element={<Network />} />
        <Route path="locations" element={<Locations />} />
        <Route path="documents" element={<Documents />} />
        <Route path="devices" element={<Devices />} />
        <Route path="servicing" element={<Servicing />} />
        <Route path="alerts" element={<Alerts />} />
        <Route path="integrations" element={<Integrations />} />
        <Route path="settings" element={<Settings />} />
        <Route path="profile" element={<Profile />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App grain">
      <BrandingProvider>
        <AuthProvider>
          <AccessGate>
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
            <Toaster position="top-right" theme="light" richColors />
          </AccessGate>
        </AuthProvider>
      </BrandingProvider>
    </div>
  );
}

export default App;
